module.exports = __webpack_public_path__ + "static/avatar-bd91a2f79c245be5452ba5b71f7f6610.jpg";